import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('index.description');
  const subtitle = store.$i18n.t('index.subtitle');
  const title = store.$i18n.t('index.title');
  store.commit('pageContent/setHead', { description, title });
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'expanded' });
};
